import React, { useCallback, useEffect, useMemo } from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import { MessageErrorInput } from 'Components/Message/Error/input'

import ArrowIcon from 'Assets/Images/icons/arrow'
import { globalSort } from '../../../shared/libraries/sort'
import { useFormChildLogic } from '../index'

export const SelectDashboardUnstyled = props => {
  useEffect(() => {
    if (props.value !== undefined) {
      updateForm(props.value)
    }
  }, [props.value])

  const options = getSelectOptions({
    options: props.options,
    sorted: props.sorted,
    ASC: props.ASC,
  })

  var input = props.input || {
    value: props.value,
    name: props.name,
    disabled: props.disabled,
    ...props.input,
  }

  useEffect(() => {
    props.shouldListenToInputValue && updateForm(input.value)
  }, [input])

  // Some old components are still using "validate" prop
  const validator = props.validator || props.validate

  const { updateForm, value, error } = useFormChildLogic({
    name: props.name,
    validator,
    initValue: props.initValue,
  })
  const errorStyles = useMemo(
    () =>
      renderError(props, error)
        ? { border: '1px solid red', borderRadius: '4px' }
        : {},
    [error, props],
  )

  const handleChange = useCallback(
    (...args) => {
      const value = args[2]

      if (props.onChange) {
        props.onChange(...args)
      }

      if (input.onChange) {
        input.onChange(value)
      }

      props.onChangeCb && props.onChangeCb(value, args[1])

      updateForm(value)
    },
    [validator],
  )
  return (
    <div className="select-wrapper" id={props.id} style={props.style}>
      <div className={`${props.className} form-select`}>
        <div className="labelContainer">
          {props.label && <label>{props.label}</label>}
          {renderError(props, error)}
        </div>
        <div className="select-wrapper" cypress_id={props.cypress_id}>
          <SelectField
            className="select-field"
            options={props.options}
            name={input.name}
            value={value || input.value}
            multiple={input.multiple}
            disabled={input.disabled}
            onChange={handleChange}
            iconStyle={{
              fill: 'none',
            }}
            menuStyle={errorStyles}
          >
            {props.hasPrimaryText && (
              <MenuItem
                primaryText={props.primaryText}
                value={null}
                cypress_id={`${props.cypress_id}-menu-item`}
              />
            )}
            {options.map((option, idx) => (
              <MenuItem
                key={idx}
                primaryText={option.label}
                value={option.value}
                disabled={option.disabled}
                leftIcon={option.icon}
                cypress_id={`${props.cypress_id}-menu-item`}
              />
            ))}
          </SelectField>
          <ArrowIcon />
        </div>
      </div>
    </div>
  )
}

/**
 * Render field error
 * @returns JSX.Element | null
 */
function renderError(props, error) {
  const { meta = {}, error: propsError } = props
  const inputError = (meta.touched && meta.error) || propsError || error

  return inputError ? (
    <MessageErrorInput key="errorMessage" message={inputError} />
  ) : null
}

const getSelectOptions = ({ options, sorted, ASC }) => {
  if (sorted) {
    return globalSort({
      data: options,
      sortingKey: 'label',
      ASC,
    })
  } else {
    return options
  }
}
